define([], function () {
    'use strict';

    const controllerType = 'platform.components.AppController';

    return function shouldShowAppController(argsObj) {
        if (argsObj.compType === controllerType) {
            return argsObj.renderFlags.componentViewMode === 'editor' && !argsObj.isMobile && argsObj.isVisible;
        }
        return true;
    };
});
